/* @flow */
import Image from '@/components/ui/image/Image'
import React from 'react' 
class PushNotification extends React.PureComponent {
  handleClick() {
    const { onMessageClick } = this.props
    if (onMessageClick) {
      onMessageClick(import.meta.env.VITE_FRONT_URL)
    }
  }

  render() {
    const { title, body, image, icon } = this.props
    return (
      <div className="flex items-center gap-4" onClick={this.handleClick.bind(this)}>
        {icon && icon}
        {image && <Image className="message__image message__image--square" src={image} alt={title} title={title} />}
        <div className="message__text">
          <div className="message__main-text">{title}</div>
          {body && <div className="message__sub-text">{body}</div>}
        </div>
      </div>
    )
  }
}

export default PushNotification
